import { Component, inject, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import {
  PreviewAddLicencesResponse,
  SubscriptionsService
} from '../../../../services/subscriptions'
import { BehaviorSubject, take, tap } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { CommonModule } from '@angular/common'
import { PaymentsService } from '../../../../services/payments.service'
import { eps } from '../../../../services/url.service'
import { RazorpayService } from '../../../../services/razorpay.service'
import { AuthState, selectUser } from '../../../../store/auth/auth.state'
import { Store } from '@ngrx/store'

@Component({
  selector: 'app-add-licence-preview',
  imports: [CommonModule],
  templateUrl: './add-licence-preview.component.html',
  styleUrl: './add-licence-preview.component.scss'
})
export class AddLicencePreviewComponent implements OnInit {
  private router = inject(Router)
  private route = inject(ActivatedRoute)
  private toastr = inject(ToastrService)
  private subscriptions = inject(SubscriptionsService)
  private payments = inject(PaymentsService)
  private razorpayService = inject(RazorpayService)
  subscriptionId = ''
  newTotalLicences = 0
  previewAddLicencesResponse$ = new BehaviorSubject<null | PreviewAddLicencesResponse>(null)
  isProcessingPayment = false
  private store = inject(Store)
  user: AuthState['user'] | null = null
  ngOnInit() {
    this.subscriptionId = this.route.snapshot.paramMap.get('id') ?? ''
    this.newTotalLicences = Number(this.route.snapshot.queryParamMap.get('newTotalLicences')) ?? 0

    this.subscriptions
      .previewAddLicences(this.subscriptionId, this.newTotalLicences)
      .pipe(take(1))
      .subscribe({
        next: data => {
          this.previewAddLicencesResponse$.next(data)
        },
        error: err => {
          this.toastr.error(err.error.message, err.error.error)
          this.router.navigate([eps.planAndBilling.planPath])
        }
      })

    this.store
      .select(selectUser)
      .pipe(
        take(1),
        tap(user => {
          this.user = user
        })
      )
      .subscribe()
  }

  confirmAddLicences() {
    if (this.isProcessingPayment) return
    this.isProcessingPayment = true
    const previewData = this.previewAddLicencesResponse$.value
    this.payments
      .initiateAddLicences(
        this.subscriptionId,
        this.newTotalLicences,
        previewData?.summary?.addedLicences
      )
      .pipe(take(1))
      .subscribe({
        next: response => {
          // Scenario A: No Payment needed (fully covered by credits)
          if (response.type === 'success') {
            this.toastr.success(response.message || 'Licences added successfully!')
            this.router.navigate([eps.planAndBilling.planPath])
          }
          // Scenario B: Payment Required (Order created)
          else if (response.type === 'order') {
            this.showRazorpayCheckout(response)
          }
        },
        error: err => {
          this.isProcessingPayment = false
          this.toastr.error(err.error?.message || 'Failed to initiate transaction.')
        }
      })
  }

  private showRazorpayCheckout(initiationResponse: any): void {
    const previewData = this.previewAddLicencesResponse$.value

    this.razorpayService
      .load()
      .then(() => {
        const options = {
          key: initiationResponse.key,
          order_id: initiationResponse.orderId,

          name: 'AVR HRMS',
          description: `Adding ${previewData?.summary?.addedLicences} Licences`,

          handler: (response: any) => {
            // Success Callback: The Webhook will handle the actual backend update.
            // We just notify the user and redirect.
            // console.log('Razorpay payment success:', response)
            this.toastr.success('Payment successful! Licences are being updated.')
            this.router.navigate([eps.planAndBilling.planPath])
          },

          prefill: {
            // Optional: Prefill user details
            name: this.user?.name ?? '',
            email: this.user?.email ?? '',
            contact: this.user?.mobile ?? ''
          },

          notes: {
            context: 'ADD_LICENCES',
            subscriptionId: this.subscriptionId,
            newTotalLicences: this.newTotalLicences,
            addedLicences: previewData?.summary?.addedLicences ?? 0
          },

          modal: {
            ondismiss: () => {
              this.isProcessingPayment = false
              this.toastr.info('Payment cancelled.')
            }
          },

          theme: {
            color: '#3399cc'
          }
        }

        const rzp = new window.Razorpay(options)
        rzp.on('payment.failed', (response: any) => {
          this.isProcessingPayment = false
          this.toastr.error(response.error.description || 'Payment failed')
        })
        rzp.open()
      })
      .catch(error => {
        console.error('Failed to load Razorpay script', error)
        this.toastr.error('Could not connect to payment gateway.')
        this.isProcessingPayment = false
      })
  }

  //getAddLicencesPaymentLink() {
  //  this.payments
  //    .getAddLicencesPaymentLink(this.subscriptionId, this.newTotalLicences)
  //    .pipe(take(1))
  //    .subscribe(r => {
  //      if (r.message && !r.paymentNeeded && !r.redirectUrl) {
  //        this.toastr.success(r.message)
  //        this.router.navigate([eps.planAndBilling.planPath])
  //      }
  //      if (r.paymentNeeded && r.redirectUrl) window.location.href = r.redirectUrl
  //    })
  //}
}
